const KawaiiEpsStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static"> 

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://open.spotify.com/album/0IqSbY1aTlQzXwSsIyJoeo?si=7XAmnJ1iRUOcrCXXRC-H-g" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-725aVzztbF5NzClY-oSS88A-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Kawaii Ry & Leesta - Green Dot</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://open.spotify.com/album/6V2daPLMFTZbhNMGQUN9e5?si=GYGU7EMjQHaH0A0VrRcoUA" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-M0iURrDPpvvoSZT9-nWUIZg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>The Porch</strong><br/>
                (prod. STEFANO)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://open.spotify.com/album/66hR39PDDqiJrKfvaNgm04" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d0000b273c2e40b9ca6e14145aecac252" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>BLEEZY SEAZY II</strong><br/>
                (prod. chris6lair)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://open.spotify.com/album/4x1pls8MUxYQW4X6XHaw3w?si=_Y80wmryRaa51Tp7itZsQg" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d0000b273c14e90e6caa1072827e7a18b" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Make Your World</strong><br/>
                (prod. Jang)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://open.spotify.com/album/0VAN9MbMhclX7vKhwVWfuE?si=o8L1FlcTQvqEmMR_KakeqQ" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-aPzQtNEpZZ9vfZFQ-8gqmoA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>USED 2 THE HATE</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://soundcloud.com/kawaiiry/sets/bleezy-seazy" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-w7LojHOCn7pzzJz6-5ChH1Q-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>BLEEZY SEAZY VOL. 1</strong><br/>
                (prod. chris6lair)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://open.spotify.com/album/4b2bNbXYAxIWvz7g6pVYVB?si=7sb-59arR8iVOlfhCj6zpA" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-KSDnl3ihOK4mzmJM-n6cKLQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>MEAUXGEIST (Hellscape Halloween Vol. 1)</strong><br/>
                (prod. Meauxminy & Geist)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://soundcloud.com/kawaiiry/sets/ugly-tape" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-wckpAbEaOz0AbvyM-odUPvw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Executive</strong><br/>
                (prod. uglyboy)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://soundcloud.com/kawaiiry/sets/one-left" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-Q4zox4LUoIM5aTyY-vfsBrg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>one left</strong>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://soundcloud.com/kawaiiry/sets/acoustic-treatment" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-maT9lRt2BBtnMwg3-jZ4VKQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Acoustic Treatment</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://soundcloud.com/kawaiiry/sets/sunday-tunes" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-6yTCkFzKMGrNXQz9-zTvYtQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Sunday Chunes</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Mixtape</p>
            <a href="https://soundcloud.com/kawaiiry/sets/kawaiis-archives-vol-1" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-GlX4ANTrmFCQA1I5-AusZ1Q-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii's Archives Vol. 1 "Diamond Run"</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://soundcloud.com/kawaiiry/sets/switch-it-up-prod-notamachine" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-zdZKxCZ31L0a8AVM-375WVg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Switch It Up</strong><br/>
                (prod. notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://soundcloud.com/kawaiiry/sets/phonk-wave" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-5bjONhx1tMyB9MZM-BDEfyg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>After Hours</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://soundcloud.com/kawaiiry/sets/rip-hyperpop" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-Szt88q4Fuc2vXg6r-FBABWQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>RIP Hyperpop</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://soundcloud.com/kawaiiry/sets/rare-form" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-jCWjW79jlX16FWfT-heQn0g-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Rare Form</strong><br/>
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://soundcloud.com/kawaiiry/sets/off-rip-ep" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-SRXfoa59wlkrXuLc-dAt4gA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry & Lil Dujour - Off Rip</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://soundcloud.com/kawaiiry/sets/still-dreaming-ep" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-JeLnYTfsB5fpiULe-BlyBAQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Still Dreaming</strong><br/>
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://soundcloud.com/kawaiiry/sets/glitch-realm-ep" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-c4lUNRQ9kq2VZ9Lp-pwya1Q-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Glitch Realm</strong><br/>
                (prod. Baredex)
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://soundcloud.com/kawaiiry/sets/kill-the-old-me-ep" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-G4PLdfHrtZ5eO43Y-mJI0KQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kill the Old Me</strong><br/>
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://soundcloud.com/kawaiiry/sets/closed-curtains-ep" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-ZUVxZpT2WUL1uUTY-T0JrMQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Closed Curtains</strong><br/>
                (prod. Curtains)
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://soundcloud.com/kawaiiry/sets/too-deep-ep-1" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-4O7F1xmti53F7pFf-14wdCg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Too Deep</strong><br/>
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://soundcloud.com/kawaiiry/sets/freakshow-ep" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-F9hNib4IAF0IwrfA-LTreyA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Freakshow</strong><br/>
              </p>
            </a>
          </div>                                                                                                                                
        
        </div>
      </>
    );
  };
  export default KawaiiEpsStatic;